import _ from 'lodash'
import { useLocalStorage } from '@vueuse/core'
import { createConversation, sortConversation, createInform } from '@/utils/handleSomeData'
import { parseAsChinaTime } from '@/utils/chinaTime'
import Message from './message'
import { EaseChatClient } from '@/IM/initwebsdk'
import { informType, messageType } from '@/constant'
import { sessionListList, sessionListListPagae } from '@/api/custom'
import router from '@/router'
import { ElLoading } from 'element-plus'
/* route */
// const route = useRoute()
// /* router */
// const router = useRouter()
const { INFORM_FROM } = informType
const { CHAT_TYPE } = messageType
const unreadStorageKey = (userId) => `EASEIM_${userId}_conversationUnread`
const unreadCount = (value) => {
  const count = Number(value)
  return Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0
}

const readCachedUnread = (userId) => {
  if (!userId) return {}
  try {
    const saved = localStorage.getItem(unreadStorageKey(userId))
    // 兼容之前已经保存的会话列表。
    const source = JSON.parse(saved === null
      ? localStorage.getItem(`EASEIM_${userId}_conversationList`) || '{}'
      : saved)
    const counts = {}
    Object.entries(source || {}).forEach(([key, value]) => {
      const count = unreadCount(saved === null ? value?.unreadMessageNum : value)
      if (count > 0) counts[key] = count
    })
    return counts
  } catch (error) {
    return {}
  }
}

const saveCachedUnread = (state) => {
  const userId = EaseChatClient.user
  if (userId) localStorage.setItem(unreadStorageKey(userId), JSON.stringify(state.cachedUnreadMap))
}

const saveConversationList = (state) => {
  const userId = EaseChatClient.user
  if (userId) localStorage.setItem(`EASEIM_${userId}_conversationList`, JSON.stringify(state.conversationListData))
}

const groupKeyStorageKey = (userId) => `EASEIM_${userId}_groupConversationKeys`

const readCachedGroupKeys = (userId) => {
  if (!userId) return {}
  try {
    const saved = JSON.parse(localStorage.getItem(groupKeyStorageKey(userId)) || '[]')
    const keys = {}
    ;(Array.isArray(saved) ? saved : Object.keys(saved || {})).forEach((key) => {
      if (key) keys[key] = true
    })
    return keys
  } catch (error) {
    return {}
  }
}

const saveGroupKeys = (state) => {
  const userId = EaseChatClient.user
  if (userId) localStorage.setItem(groupKeyStorageKey(userId), JSON.stringify(Object.keys(state.groupKeySet)))
}

const rememberGroupKeys = (state, conversations) => {
  const next = { ...(state.groupKeySet || {}) }
  let changed = false
  Object.entries(conversations || {}).forEach(([key, conversation]) => {
    if (!key || conversation?.conversationType !== CHAT_TYPE.GROUP || next[key]) return
    next[key] = true
    changed = true
  })
  if (!changed) return
  state.groupKeySet = next
  saveGroupKeys(state)
}

const hasUnread = (state, key) =>
  unreadCount(state.conversationListData[key]?.unreadMessageNum) > 0 || unreadCount(state.cachedUnreadMap[key]) > 0

const rememberUnread = (state, key, value) => {
  const count = unreadCount(value)
  if (count > 0) state.cachedUnreadMap[key] = count
  else delete state.cachedUnreadMap[key]
}

const restoreUnread = (state, conversations) => {
  Object.entries(conversations).forEach(([key, conversation]) => {
    const current = state.conversationListData[key]
    conversation.unreadMessageNum = current
      ? unreadCount(current.unreadMessageNum)
      : unreadCount(state.cachedUnreadMap[key])
    rememberUnread(state, key, conversation.unreadMessageNum)
  })
  return conversations
}

const readCachedConversations = (userId, unreadMap) => {
  if (!userId) return {}
  try {
    const cached = JSON.parse(localStorage.getItem(`EASEIM_${userId}_conversationList`) || '{}')
    Object.entries(cached || {}).forEach(([key, conversation]) => {
      conversation.unreadMessageNum = unreadCount(unreadMap[key])
    })
    return sortConversation(cached || {})
  } catch (error) {
    return {}
  }
}

const Conversation = {
  state: {
    informDetail: [],
    conversationListData: {},
    cachedUnreadMap: {},
    isUnread: false,
    tempData: {},
    userType: 'erp', //默认为erp，表示客服等管理人员，如果是用户，变为customer
    isNextPage: true, //是否有下一页
    showHiddenGroups: false, // 是否显示折叠禁言的群聊列表
    pinnedConversationCount: 0, // 全部正常会话中的置顶数量，不受列表标签筛选影响
    // @已读标记：conversationKey -> true
    // 进入会话即标记已读；收到新的@我消息时由 RESET_REFER_ME 撤销
    // 不用消息id比对：接口返回的 messageId 与环信消息 id 来源不同，比对会失配
    atReadMap: {},
    // 未读@提醒独立于最新消息，后续普通消息和列表刷新都不能覆盖它
    atUnreadMap: {},
    // 出现过的群会话 id。切到私聊等标签后列表会被换成当前页，仍要能清掉这些群的未读
    groupKeySet: {},
  },
  mutations: {
    // 是否有下一页
    SET_isNextPage: (state, value) => {
      state.isNextPage = value
    },
    SET_PINNED_CONVERSATION_COUNT: (state, count) => {
      state.pinnedConversationCount = count
    },
    ADJUST_PINNED_CONVERSATION_COUNT: (state, change) => {
      state.pinnedConversationCount = Math.max(0, state.pinnedConversationCount + change)
    },
    // 切换折叠群聊列表显示状态
    TOGGLE_HIDDEN_GROUPS: (state) => {
      state.showHiddenGroups = !state.showHiddenGroups
    },
    // 设置折叠群聊列表显示状态
    SET_SHOW_HIDDEN_GROUPS: (state, value) => {
      state.showHiddenGroups = value
    },
    // 改变userType
    UPDATE_userType: (state, temp) => {
      state.userType = temp
    },
    // 从erp进来后 如果有未读消息，调用此方法更新未读标识
    UPDATE_UN_READ_NUM: (state, temp) => {
      state.isUnread = true
      state.tempData = temp
    },
    //初始化会话列表的数据（根据登陆的id取其对应的会话数据）
    INIT_CONVERSATION_STATE: (state, temp) => {
      // 无参数调用用于登录初始化，避免沿用上个账号的@状态
      if (!temp) {
        state.atReadMap = {}
        state.atUnreadMap = {}
        state.pinnedConversationCount = 0
        state.cachedUnreadMap = readCachedUnread(EaseChatClient.user)
        state.groupKeySet = readCachedGroupKeys(EaseChatClient.user)
        state.conversationListData = readCachedConversations(EaseChatClient.user, state.cachedUnreadMap)
        rememberGroupKeys(state, state.conversationListData)
      }
      const storageId = EaseChatClient.user
      state.informDetail = useLocalStorage(`EASEIM_${storageId}_INFORM`, [])
      if (!temp) return
      const sortedData = sortConversation(restoreUnread(state, _.cloneDeep(temp)))

      if (state.isUnread && sortedData[Object.keys(state.tempData)[0]]) {
        state.isUnread = false
        let keys = Object.keys(state.tempData)
        keys.forEach((key) => {
          if (state.tempData[key]) {
            sortedData[key].unreadMessageNum = state.tempData[key]
          }
        })
      }
      state.conversationListData = sortedData
      localStorage.setItem(`EASEIM_${storageId}_conversationList`, JSON.stringify(sortedData))
      Object.entries(sortedData).forEach(([key, conversation]) => rememberUnread(state, key, conversation.unreadMessageNum))
      saveCachedUnread(state)
      rememberGroupKeys(state, sortedData)
    },
    //设置新一页的会话列表
    SET_CONVERSATION_LIST_MORE: (state, temp) => {
      const storageId = EaseChatClient.user
      state.informDetail = useLocalStorage(`EASEIM_${storageId}_INFORM`, [])
      const sortedData = sortConversation(restoreUnread(state, _.cloneDeep(temp || {})))
      state.conversationListData = { ...state.conversationListData, ...sortedData }
      localStorage.setItem(`EASEIM_${storageId}_conversationList`, JSON.stringify(state.conversationListData))
      saveCachedUnread(state)
      rememberGroupKeys(state, sortedData)
    },
    //清空系统通知
    CLEAR_INFORM_LIST: (state) => {
      state.informDetail = []
    },
    //更新系统通知
    UPDATE_INFORM_LIST: (state, informBody) => {
      const toBeUpdateInform = _.assign([], state.informDetail)
      // let _index = toBeUpdateInform.findIndex(
      //   (v) => v.from === informBody.from
      // );
      // if (_index === -1) {
      //   toBeUpdateInform.unshift(informBody);
      // } else {
      //   toBeUpdateInform.splice(_index, 1);
      //   toBeUpdateInform.unshift(informBody);
      // }
      toBeUpdateInform.unshift(informBody)
      state.informDetail = toBeUpdateInform
    },
    //更新已有会话
    UPDATE_CONVERSATION_LIST: (state, payload) => {
      const groupCandidates = {}
      Object.entries(payload).forEach(([key, updated]) => {
        const previous = state.conversationListData[key]
        if (previous?.conversationType === CHAT_TYPE.GROUP || updated?.conversationType === CHAT_TYPE.GROUP) {
          groupCandidates[key] = { conversationType: CHAT_TYPE.GROUP }
        }
        if (!previous || previous.isTop != 1 || updated.isTop != 1) return
        if (previous.isCancel != 2 && updated.isCancel == 2) state.pinnedConversationCount = Math.max(0, state.pinnedConversationCount - 1)
        if (previous.isCancel == 2 && updated.isCancel != 2) state.pinnedConversationCount += 1
      })
      const sortedData = sortConversation({ ...state.conversationListData, ...payload })
      state.conversationListData = sortedData
      Object.entries(payload).forEach(([key, conversation]) => {
        if (conversation.unreadMessageNum !== undefined) rememberUnread(state, key, conversation.unreadMessageNum)
      })
      saveCachedUnread(state)
      saveConversationList(state)
      rememberGroupKeys(state, groupCandidates)
    },
    UPDATE_CONVERSATION_ORDER_STATUS: (state, { conversationKey, orderStatus }) => {
      const conversation = state.conversationListData[conversationKey]
      if (!conversation || orderStatus === undefined || orderStatus === null) return
      state.conversationListData = {
        ...state.conversationListData,
        [conversationKey]: { ...conversation, orderStatus },
      }
      localStorage.setItem(
        `EASEIM_${EaseChatClient.user}_conversationList`,
        JSON.stringify(state.conversationListData),
      )
    },
    //删除某条会话
    DELETE_ONE_CONVERSATION: (state, key) => {
      //console.log('>>>>>>>执行删除会话操作', key)
      const toUpdateConversation = _.assign({}, state.conversationListData)
      if (toUpdateConversation[key]) {
        if (toUpdateConversation[key].isTop == 1 && toUpdateConversation[key].isCancel != 2) {
          state.pinnedConversationCount = Math.max(0, state.pinnedConversationCount - 1)
        }
        delete toUpdateConversation[key]
      }
      //console.log('删除后toUpdateConversation', toUpdateConversation)
      state.conversationListData = _.assign({}, toUpdateConversation)
      delete state.cachedUnreadMap[key]
      saveCachedUnread(state)
      saveConversationList(state)
      delete state.atReadMap[key]
      delete state.atUnreadMap[key]
      if (state.groupKeySet[key]) {
        const nextGroupKeys = { ...state.groupKeySet }
        delete nextGroupKeys[key]
        state.groupKeySet = nextGroupKeys
        saveGroupKeys(state)
      }
    },
    //清除会话未读状态
    CLEAR_UNREAD_NUM: (state, key) => {
      //会话可能尚未加载/已被分页移除/已被删除，此处必须做空值保护
      const conversation = key === undefined || key === null ? null : state.conversationListData[key]
      if (!conversation) return
      if (!conversation.unreadMessageNum && !state.cachedUnreadMap[key]) return
      conversation.unreadMessageNum = 0
      rememberUnread(state, key, 0)
      saveCachedUnread(state)
      saveConversationList(state)
    },
    // 一键已读：只清传入的群会话红点，@我的会话不会出现在 keys 里
    CLEAR_GROUP_UNREAD: (state, keys) => {
      if (!keys?.length) return
      let changed = false
      keys.forEach((key) => {
        const conversation = state.conversationListData[key]
        if (conversation?.unreadMessageNum) {
          conversation.unreadMessageNum = 0
          changed = true
        }
        if (state.cachedUnreadMap[key]) {
          rememberUnread(state, key, 0)
          changed = true
        }
      })
      if (!changed) return
      saveCachedUnread(state)
      saveConversationList(state)
    },
    //清除会话提到自己：标记该会话的@已读
    // 已读后同时清除独立的@提醒，列表重新加载也不应恢复旧提醒
    CLEAR_REFER_ME: (state, key) => {
      if (key === undefined || key === null) return
      if (!state.conversationListData[key]) return
      state.atReadMap = { ...state.atReadMap, [key]: true }
      delete state.atUnreadMap[key]
    },
    //收到新的@我消息：撤销已读标记，让@前缀重新亮起
    RESET_REFER_ME: (state, key) => {
      if (key === undefined || key === null) return
      const next = { ...state.atReadMap }
      delete next[key]
      state.atReadMap = next
      state.atUnreadMap = { ...state.atUnreadMap, [key]: true }
    },
    //清除信息卡片未读
    CLEAR_UNTREATED_STATUS: (state, index) => {
      //console.log('>>>>>执行清除卡片未读', index)
      state.informDetail[index].untreated = 0
    },
    //更改卡片消息的按钮状态
    UPDATE_INFORM_BTNSTATUS: (state, { index: index, btnStatus }) => {
      //console.log('>>>>触发了按钮更新状态', index, btnStatus)
      state.informDetail[index].operationStatus = btnStatus
    },
  },
  actions: {
    // 只清群聊未读。有人@你的群保留红点和@前缀，私聊不在范围内
    markGroupChatsRead: ({ state, commit }) => {
      const keys = new Set()
      Object.entries(state.conversationListData).forEach(([key, item]) => {
        if (item?.conversationType === CHAT_TYPE.GROUP) keys.add(key)
      })
      Object.keys(state.groupKeySet || {}).forEach((key) => keys.add(key))
      const toClear = []
      let kept = 0
      keys.forEach((key) => {
        if (!hasUnread(state, key)) return
        if (state.atUnreadMap[key]) {
          kept += 1
          return
        }
        toClear.push(key)
      })
      if (toClear.length) commit('CLEAR_GROUP_UNREAD', toClear)
      return { cleared: toClear.length, kept }
    },
    // 初始化会话列表
    getSessionList: async ({ commit, dispatch }, payload) => {
      let tempObj = {}
      const limit = 30
      const { userId, filterParams = {} } = payload || {}
      try {
        const params = {
          // formUser: userId,
          limit: limit,
          isCancel: 1, // 默认只查询未折叠禁言的群聊
          ...filterParams,
        }
        let { rows, total } = await sessionListList(params)
        console.log('rows:', !!rows, 'total:', total, 'limit:', limit, 'rows.length:', rows?.length)

        // 首屏接口会附带该账号的全部置顶会话；仅从未筛选的正常列表更新全局数量。
        if (params.isCancel == 1 && !params.msgType && !params.groupType && !params.status) {
          const pinnedIds = new Set((rows || []).filter((item) => item.isTop == 1).map((item) => item.sessionId))
          commit('SET_PINNED_CONVERSATION_COUNT', pinnedIds.size)
        }

        // 修复逻辑：当返回的数据数量小于请求的limit，说明没有更多数据了
        if (!rows || rows.length < limit) {
          commit('SET_isNextPage', false)
        } else {
          commit('SET_isNextPage', true)
        }
        tempObj = await dispatch('huihuaFormat', { rows, userId }) || {}
      } catch (error) { return }
      if (EaseChatClient.user !== userId) return
      commit('INIT_CONVERSATION_STATE', tempObj)
    },
    // 会话列表  获取下一页
    getSessionListLimitPage: async ({ commit, dispatch }, params) => {
      // console.log("%c Line:175 🥔 获取下一页params", "color:#3f7cff", params);
      let tempObj = {}
      const { formUser, yuduChatId, updateTime } = params
      const limit = 30
      try {
        const loading = ElLoading.service({
          lock: true,
          text: '加载中...',
          background: 'rgba(255, 255, 255, 0.7)',
        })
        let { rows, total } = await sessionListListPagae({
          formUser: formUser,
          limit: limit,
          id: yuduChatId,
          updateTime: updateTime,
          groupType: params.groupType,
          status: params.status,
          isCancel: params.isCancel !== undefined ? params.isCancel : 1, // 默认只查询未折叠禁言的群聊
        })
        console.log('分页加载 - rows:', !!rows, 'total:', total, 'limit:', limit, 'rows.length:', rows?.length)

        // 修复逻辑：当返回的数据数量小于请求的limit，说明没有更多数据了
        if (!rows || rows.length < limit) {
          commit('SET_isNextPage', false)
        } else {
          commit('SET_isNextPage', true)
        }
        tempObj = await dispatch('huihuaFormat', { rows, userId: formUser })
        loading.close()
      } catch (error) {}
      commit('SET_CONVERSATION_LIST_MORE', tempObj)
    },
    // 处理会话格式
    huihuaFormat: async ({ commit, state }, params) => {
      const { rows, userId } = params
      const tempObj = {}
      if (rows && rows.length) {
        for (let i = 0; i < rows.length; i++) {
          let item = rows[i]
          let msgtxt = item.type == 'text' ? item.content : ''
          let type = 'txt'
          if (item.type == 'custom') {
            type = 'custom'
            if (item.customType == 'image') {
              msgtxt = '[图片]'
            } else if (item.customType == 'video') {
              msgtxt = '[视频]'
            } else if (item.customType == 'goods') {
              msgtxt = '[商品]'
            } else if (item.customType == 'backlist') {
              msgtxt = '[回收记录]'
            } else if (item.customType == 'b_backlist') {
              msgtxt = '[回收记录]'
            } else if (item.customType == 'info') {
              msgtxt = '[提示信息]'
            } else if (item.customType == 'audio') {
              msgtxt = '[语音]'
            } else if (item.customType == 'productApply') {
              msgtxt = '[捆绑包结算确认]'
            } else {
              msgtxt = '[其他]'
            }
          }

          if (item.msgType == 2) {
            // 群组
            tempObj[item.sessionId] = {
              yuduChatId: item.id,
              sessionId: item.sessionId,
              isTop: item.isTop,
              conversationType: 'groupChat',
              conversationKey: item.sessionId,
              avatarUrl: item.avatarUrl,
              conversationInfo: {
                name: item.groupName,
                avatarUrl: '',
              },
              fromInfo: {
                fromId: item.formUser,
                fromName: '',
              },
              targetId: item.sessionId,
              unreadMessageNum: 0,
              latestMessage: {
                msg: msgtxt,
                type: type,
                ext: {
                  timeout: 1,
                },
              },
              latestMessageId: item.messageId,
              latestSendTime: item.updateTime
                ? parseAsChinaTime(item.updateTime)
                : parseAsChinaTime(item.createTime),
              groupName: item.groupName,
              goodsType: item.groupType,
              groupType: item.groupType,
              status: item.status,
              orderStatus: item.orderStatus,
              isCancel: item.isCancel,
            }
            if (state.conversationListData[item.sessionId]) {
              tempObj[item.sessionId]['unreadMessageNum'] =
                state.conversationListData[item.sessionId]['unreadMessageNum']
            }
          } else {
            // 单聊
            let targetId = item.formUser == userId ? item.toUser : item.formUser
            //console.log("%c Line:154 🍇 targetId", "color:#e41a6a", targetId);
            tempObj[targetId] = {
              yuduChatId: item.id,
              sessionId: item.sessionId,
              isTop: item.isTop,
              conversationType: 'singleChat',
              conversationKey: targetId,
              conversationInfo: {
                name: item.formUser == userId ? item.toNickName : item.fromNickName,
                avatarUrl: item.formUser == userId ? item.toAvatar : item.fromAvatar,
              },
              fromInfo: {
                fromId: item.formUser,
                fromName: item.fromNickName,
              },
              targetId: targetId,
              // localChat[item.sessionId]&&localChat[item.sessionId].unreadMessageNum?localChat[item.sessionId].unreadMessageNum: 0
              unreadMessageNum: 0,
              latestMessage: {
                msg: msgtxt,
                type: type,
                ext: {
                  timeout: 1,
                },
              },
              latestMessageId: item.messageId,
              latestSendTime: item.updateTime
                ? parseAsChinaTime(item.updateTime)
                : parseAsChinaTime(item.createTime),
              isCancel: item.isCancel,
            }
            if (state.conversationListData[targetId]) {
              tempObj[targetId]['unreadMessageNum'] = state.conversationListData[targetId]['unreadMessageNum']
            }
          }
        }

        return tempObj
      }
    },
    //添加新系统通知
    createNewInform: ({ dispatch, commit }, params) => {
      const { fromType, informContent } = params
      //console.log('>>>>>>>>>createNewInform', fromType, informContent)
      const result = createInform(fromType, informContent)
      commit('UPDATE_INFORM_LIST', result)

      //部分事件需要调用接口更新本地信息或者增加消息内系统通知
      if (fromType === INFORM_FROM.FRIEND) {
        const informMsg = {
          from: informContent.from,
          to: informContent.to,
          chatType: CHAT_TYPE.SINGLE,
        }
        switch (informContent.type) {
          case 'other_person_agree':
            {
              dispatch('fetchFriendList')
            }

            break
          case 'unsubscribed':
            {
              informMsg.msg = '你俩的友尽了，可重新发起好友申请'
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'subscribed':
            {
              informMsg.msg = '已成为你的好友,开始聊天吧'
              dispatch('createInformMessage', informMsg)
            }
            break
          default:
            break
        }
      }
      if (fromType === INFORM_FROM.GROUP) {
        const informMsg = {
          from: informContent.from,
          to: informContent.id,
          chatType: CHAT_TYPE.GROUP,
        }
        switch (informContent.operation) {
          case 'memberPresence': //入群通知
            {
              // informContent
              //console.log("%c Line:245 🥚 入群通知informContent", "color:#ea7e5c", informContent);
              commit('UPDATE_GROUP_INFOS', {
                groupId: informContent.id,
                type: 'addAffiliationsCount',
              })
              dispatch('fetchGoupsMember', informContent.id)
              informMsg.msg = `${informContent.from}加入了群组`
              dispatch('createInformMessage', informMsg)
              // dispatch('getGroupPersons', {
              // 	groupId: informContent.id,
              // 	fromHxId: EaseChatClient.user,
              // })
            }
            break
          case 'memberAbsence':
            {
              //退群通知
              commit('UPDATE_GROUP_INFOS', {
                groupId: informContent.id,
                type: 'delAffiliationsCount',
              })
              dispatch('fetchGoupsMember', informContent.id)
              informMsg.msg = `${informContent.from}退出了群组`
              dispatch('createInformMessage', informMsg)
              // dispatch('getGroupPersons', {
              // 	groupId: informContent.id,
              // 	fromHxId: EaseChatClient.user,
              // })
            }
            break
          case 'updateAnnouncement':
            {
              //更新群公告
              dispatch('fetchAnnounment', informContent.id)
              informMsg.msg = `${informContent.from}更新了群组公告，去看看更新的什么吧~`
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'setAdmin':
            {
              dispatch('fetchGoupsAdmin', informContent.id)
              informMsg.msg = `${informContent.from}设定${informContent.to}为管理员~`
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'removeAdmin':
            {
              dispatch('fetchGoupsAdmin', informContent.id)
              informMsg.msg = `${informContent.from}移除了${informContent.to}的管理员身份~`
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'muteMember':
            {
              informMsg.msg = `${informContent.from}禁言了${informContent.to ? informContent.to : '你'}~`
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'unmuteMember':
            {
              informMsg.msg = `${informContent.from}取消了${informContent.to ? informContent.to : '你'}的禁言~`
              dispatch('createInformMessage', informMsg)
            }
            break
          case 'removeMember':
            {
              // informMsg.msg = `${informContent.from}将你移出了群组${informContent.id}~`
              // dispatch('createInformMessage', informMsg)
              //执行删除会话
              commit('DELETE_ONE_CONVERSATION', informContent.id)
              //从群组列表中移除
              commit('UPDATE_GROUP_LIST', {
                type: 'deleteFromList',
                groupId: informContent.id,
              })
            }
            break
          // case 'destroy':
          //   {
          //     informMsg.msg = `${informContent.from}解散了该群~`
          //     dispatch('createInformMessage', informMsg)
          //     setTimeout(() => {
          //       // dispatch('fetchGroupList', {
          //       //     pageNum: 1,
          //       //     pageSize: 600
          //       // })
          //       // 删除本地会话
          //       // 成功，删除本地会话
          //       commit('DELETE_ONE_CONVERSATION', informContent.id)
          //       // //如果删除的itemKey与当前的message会话页的id一致则跳转至会话默认页。
          //       if (router.currentRoute.value?.query?.id && router.currentRoute.value.query.id === informContent.id) {
          //         router.push('/chat/conversation')
          //       }
          //     }, 300)
          //   }
          //   break
          case 'updateInfo':
            {
              informMsg.msg = `${informContent.from}更新了群组详情~`
              dispatch('createInformMessage', informMsg)
              dispatch('getAssignGroupDetail', informContent.id)
            }
            break
          case 'acceptRequest':
            {
              //console.log('>>>>>>>收到了群组同意加入事件')
              // setTimeout(() => {
              //     dispatch('fetchGroupList', {
              //         pageNum: 1,
              //         pageSize: 600
              //     })
              // }, 300)
            }
            break
          case 'changeOwner':
            {
              //更换群主 informContent
              //console.log("%c Line:364 🍊 informContent", "color:#ffdd4d", informContent);
              dispatch('fetchAnnounment', informContent.id)
              informMsg.msg = `${informContent.from}变更了群主~`
              dispatch('createInformMessage', informMsg)
              dispatch('fetchGoupsMember', informContent.id)
              // dispatch('getGroupPersons', {
              // 	groupId: informContent.id,
              // 	fromHxId: EaseChatClient.user,
              // })
            }
            break
          default:
            break
        }
      }
      //memberPresence 群成员加入群组需要进行群组人数+1操作。
      // commit('UPDATE_GROUP_INFOS',{})
    },

    //收集会话依赖数据
    gatherConversation: async ({ commit, dispatch }, payload) => {
      const key = typeof payload === 'string' ? payload : payload.key
      const cachedMessages = Message.state.messageList[key]
      const message =
        typeof payload === 'string' ? cachedMessages?.[cachedMessages.length - 1] : payload.message
      if (!key || !message) return

      const res = await createConversation([message])
      commit('UPDATE_CONVERSATION_LIST', res)
      if (res[key] && res[key].conversationType == CHAT_TYPE.GROUP && res[key].localChat) {
        await dispatch('getGroupDetail', {
          groupId: key,
          flag: '',
        }).catch(() => {})
      }
    },
  },
}
export default Conversation
